import { render, staticRenderFns } from "./AddCustomPage.vue?vue&type=template&id=9fe48b52&"
import script from "./AddCustomPage.vue?vue&type=script&lang=js&"
export * from "./AddCustomPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports